import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=56ee8838&scoped=true&"
import script from "./ContactButton.vue?vue&type=script&lang=js&"
export * from "./ContactButton.vue?vue&type=script&lang=js&"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=56ee8838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee8838",
  null
  
)

export default component.exports